import _regeneratorRuntime from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/regeneratorRuntime.js";
import _asyncToGenerator from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/asyncToGenerator.js";
import _objectSpread from "/Users/maradith/Documents/gsapp/src/GlobalStoreMobileShoppingWebapp/node_modules/@babel/runtime/helpers/esm/objectSpread2.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.array.push.js";
import { unref as _unref, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, renderList as _renderList, Fragment as _Fragment, createElementBlock as _createElementBlock, resolveDynamicComponent as _resolveDynamicComponent, normalizeStyle as _normalizeStyle, resolveComponent as _resolveComponent, withCtx as _withCtx, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue";
var _hoisted_1 = {
  class: "gateway-wrapper",
  ondragstart: "return false"
};
var _hoisted_2 = {
  key: 0,
  class: "submit-share-area"
};
var _hoisted_3 = {
  class: "not-pipl-gateway-search"
};
var _hoisted_4 = /*#__PURE__*/_createElementVNode("div", null, null, -1);
import { useI18n } from 'vue-i18n';
import { useWindowSize } from '@vueuse/core';
import { useStore } from 'vuex';
import { useRoute, useRouter, onBeforeRouteLeave } from 'vue-router';
import { nextTick, onMounted, ref, shallowRef, onUnmounted, computed, onActivated, onBeforeMount } from 'vue';
import constants, { encryptedMarketplaceId } from '@/constants';
import { API_RESPONSE_STATUS_CODE } from '@/configs/common';
import { useLess } from '@/models/hooks';
import { Bridge } from '@/utils/bridge';
import { getWidgetPopup, getGatewayModulesInfo, getFloatingWindow } from '@/models/api/landingPageApi';
import { getType, getAccessToken, isShowPIPLConfirmAlertView, handleStartLogin, isLoginAuthenticated } from '@/utils/common';
import RecommendedAsins from '@/components/recommendedAsins/RecommendedAsins.vue';
import LoginTooltip from '@/components/popup/LoginTooltip.vue';
import FloatingWindow from '@/views/landingPage/floatingWindow/FloatingWindow.vue';
import SearchWidget from '@/views/landingPage/searchWidget/SearchWidget.vue';
import PopupWidget from '@/views/landingPage/popupWidget/PopupWidget.vue';
import { LANDING_PAGE_PARAMS_PAGE_TYPE } from '@/utils/landingPageCommon.js';
import { SET_AGENT_DATA } from '@/store/mutations.types';
import { handleOpenApp } from '@/views/detailPage/hooks/hooks.js';
import { useRecordLoadingEvent } from '@/models/hooks';
import { loadingEvents } from '@/configs/awsRumConfig';
import { gatewayWidgetComponents, LOGINTOOLTIP_ID } from '@/configs/views/landingPage.js';
import { getDeviceId } from '@/utils/device';
var BACK_TOP_DISTANCE_FROM_BOTTOM = 36;
export default {
  __name: 'Gateway',
  setup(__props) {
    useRecordLoadingEvent(duration => _objectSpread(_objectSpread({}, loadingEvents.landingPage.gatewayPage), {}, {
      duration
    }));
    useLess('views/gateway/Gateway.less');
    var _useI18n = useI18n(),
      t = _useI18n.t;
    var floatingData = shallowRef({});
    var ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP = constants.ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP,
      ENCRYPTED_MARKETPLACE_ID = constants.ENCRYPTED_MARKETPLACE_ID,
      IMAGE_URL = constants.IMAGE_URL,
      NEW_IMAGE_URL = constants.NEW_IMAGE_URL,
      _constants$SHARE_MODU = constants.SHARE_MODULE.shareRouter,
      GATEWAY = _constants$SHARE_MODU.GATEWAY,
      DETAIL_PAGE = _constants$SHARE_MODU.DETAIL_PAGE;
    var route = useRoute();
    var router = useRouter();
    var isPullRefresh = ref(false); // Dropdown refresh or not
    var isPullRefreshDisabled = ref(true);
    // Full screen component type
    var FULL_SCREEN_COMPONENTS = ['bestseller'];
    // If the type of infinite scrolling component is infinite scrolling, place this component at the end
    var WATERFALL_COMPONENTS = ['dealWidget', 'recommendedAsin'];
    var store = useStore();
    var isShowWidgetComponent = ref(false);
    var isShowLoading = ref(true);
    var RIGHT_ARROW_GREY = `${IMAGE_URL}assets/image/icons/rightArrowGrey.png`;
    var BADGE_LOGO_URL = `${NEW_IMAGE_URL}04_BadgeLogo/Logo_Settings3x.png`;
    var SEARCH_URL = `${IMAGE_URL}assets/svg/dNavSearch.svg`;
    var popupWidgetList = ref([]); // Popup advertising data
    var isLogin = ref(false);
    var isShowLoginToolTip = ref(false);
    var distanceFromTop = computed(() => {
      var _store$state$navigato, _store$state$navigato2;
      return (_store$state$navigato = (_store$state$navigato2 = store.state.navigator.agentData) === null || _store$state$navigato2 === void 0 ? void 0 : _store$state$navigato2.top) !== null && _store$state$navigato !== void 0 ? _store$state$navigato : 0;
    });
    var tabbarHeight = computed(() => {
      var _store$state$common$t;
      return (_store$state$common$t = store.state.common.tabbarHeight) !== null && _store$state$common$t !== void 0 ? _store$state$common$t : 0;
    });
    var isShowFloatingWindow = ref(false);
    var widgetList = ref([]);
    var gatewayPageHeight = ref(0);
    var recommendListRef = ref(null);
    var isNoPiplGatewayLoading = ref(false);
    var loginTooltipHeight = computed(() => {
      var _store$state$common$l, _store$state$common;
      return (_store$state$common$l = (_store$state$common = store.state.common) === null || _store$state$common === void 0 ? void 0 : _store$state$common.loginTooltipHeight) !== null && _store$state$common$l !== void 0 ? _store$state$common$l : 0;
    });
    var isPIPLAuthorized = computed(() => {
      var _store$state$common$i, _store$state$common2;
      return (_store$state$common$i = (_store$state$common2 = store.state.common) === null || _store$state$common2 === void 0 ? void 0 : _store$state$common2.isPIPLAuthorized) !== null && _store$state$common$i !== void 0 ? _store$state$common$i : false;
    });
    var onRecommendListLoading = (status, isNextPage) => {
      isPullRefresh.value = isNextPage;
      if (!isNextPage) {
        isNoPiplGatewayLoading.value = !status;
      }
      isPullRefreshDisabled.value = !status;
    };
    var handleLogin = /*#__PURE__*/function () {
      var _ref = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee() {
        return _regeneratorRuntime().wrap(function _callee$(_context) {
          while (1) switch (_context.prev = _context.next) {
            case 0:
              _context.next = 2;
              return isShowPIPLConfirmAlertView();
            case 2:
              if (!_context.sent) {
                _context.next = 4;
                break;
              }
              return _context.abrupt("return");
            case 4:
              handleStartLogin();
            case 5:
            case "end":
              return _context.stop();
          }
        }, _callee);
      }));
      return function handleLogin() {
        return _ref.apply(this, arguments);
      };
    }();
    var filterComponent = categoryType => {
      var _gatewayWidgetCompone, _gatewayWidgetCompone2;
      return (_gatewayWidgetCompone = gatewayWidgetComponents.filter(componentItem => componentItem.type === categoryType)) === null || _gatewayWidgetCompone === void 0 ? void 0 : (_gatewayWidgetCompone2 = _gatewayWidgetCompone[0]) === null || _gatewayWidgetCompone2 === void 0 ? void 0 : _gatewayWidgetCompone2.component;
    };
    var setComponentPaddingBottom = componentIndex => {
      return componentIndex + 1 === widgetList.value.length && {
        paddingBottom: `${tabbarHeight.value}px`
      };
    };
    var getWidgetPopupInfo = /*#__PURE__*/function () {
      var _ref2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee2() {
        var deviceId, params, _yield$getWidgetPopup, data, _data$data;
        return _regeneratorRuntime().wrap(function _callee2$(_context2) {
          while (1) switch (_context2.prev = _context2.next) {
            case 0:
              _context2.next = 2;
              return getDeviceId();
            case 2:
              deviceId = _context2.sent;
              params = {
                marketplaceId: encryptedMarketplaceId,
                language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID],
                paramType: 0,
                pageType: LANDING_PAGE_PARAMS_PAGE_TYPE.GATEWAY,
                deviceId,
                customerContext: {
                  personalRecStatus: true
                }
              };
              _context2.t0 = getWidgetPopup;
              _context2.t1 = params;
              _context2.next = 8;
              return getAccessToken();
            case 8:
              _context2.t2 = _context2.sent;
              _context2.next = 11;
              return (0, _context2.t0)(_context2.t1, _context2.t2);
            case 11:
              _yield$getWidgetPopup = _context2.sent;
              data = _yield$getWidgetPopup.data;
              if (data.code === API_RESPONSE_STATUS_CODE.SUCCESS) {
                popupWidgetList.value = ((_data$data = data.data) === null || _data$data === void 0 ? void 0 : _data$data.list) || [];
                Bridge.callFn('saveDataToMemoryCache', {
                  key: 'isGatewayWidgetPopupCalled',
                  value: true
                });
              }
            case 14:
            case "end":
              return _context2.stop();
          }
        }, _callee2);
      }));
      return function getWidgetPopupInfo() {
        return _ref2.apply(this, arguments);
      };
    }();
    // combineWidgetComponents shelf data
    var combineWidgetComponents = /*#__PURE__*/function () {
      var _ref3 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee3() {
        var _gatewayModulesInfo$d, params, gatewayModulesInfo;
        return _regeneratorRuntime().wrap(function _callee3$(_context3) {
          while (1) switch (_context3.prev = _context3.next) {
            case 0:
              _context3.prev = 0;
              params = {
                language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID],
                pageType: LANDING_PAGE_PARAMS_PAGE_TYPE.HOME_PAGE,
                previewMode: false,
                customerContext: {
                  personalRecStatus: true
                }
              };
              _context3.next = 4;
              return getGatewayModulesInfo(params);
            case 4:
              gatewayModulesInfo = _context3.sent;
              if ((gatewayModulesInfo === null || gatewayModulesInfo === void 0 ? void 0 : (_gatewayModulesInfo$d = gatewayModulesInfo.data) === null || _gatewayModulesInfo$d === void 0 ? void 0 : _gatewayModulesInfo$d.code) === API_RESPONSE_STATUS_CODE.SUCCESS) {
                widgetList.value = gatewayModulesInfo.data.widgets;
              } else {
                widgetList.value = constants.GATEWAY_MODULE_DEFAULT.WIDGETS;
              }
              isPullRefresh.value = false;
              isPullRefreshDisabled.value = false;
              _context3.next = 14;
              break;
            case 10:
              _context3.prev = 10;
              _context3.t0 = _context3["catch"](0);
              widgetList.value = constants.GATEWAY_MODULE_DEFAULT.WIDGETS;
              console.error('combineWidgetComponents error>>>', _context3.t0);
            case 14:
            case "end":
              return _context3.stop();
          }
        }, _callee3, null, [[0, 10]]);
      }));
      return function combineWidgetComponents() {
        return _ref3.apply(this, arguments);
      };
    }();
    var getGatewayFloatingWindow = /*#__PURE__*/function () {
      var _ref4 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee4() {
        var params, _yield$getFloatingWin, data;
        return _regeneratorRuntime().wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              _context4.prev = 0;
              params = {
                marketplaceId: ENCRYPTED_MARKETPLACE_ID,
                language: ENCRYPTED_MARKETPLACE_ID_LOCALE_MAP[ENCRYPTED_MARKETPLACE_ID],
                paramType: 0,
                pageType: LANDING_PAGE_PARAMS_PAGE_TYPE.GATEWAY
              };
              _context4.next = 4;
              return getFloatingWindow(params);
            case 4:
              _yield$getFloatingWin = _context4.sent;
              data = _yield$getFloatingWin.data;
              if (data.code === API_RESPONSE_STATUS_CODE.SUCCESS) {
                floatingData.value = (data === null || data === void 0 ? void 0 : data.data) || {};
              }
              _context4.next = 12;
              break;
            case 9:
              _context4.prev = 9;
              _context4.t0 = _context4["catch"](0);
              console.error('getFloatingWindow error>>>', _context4.t0);
            case 12:
            case "end":
              return _context4.stop();
          }
        }, _callee4, null, [[0, 9]]);
      }));
      return function getGatewayFloatingWindow() {
        return _ref4.apply(this, arguments);
      };
    }();
    var handlePageClick = e => {
      var id = e.target.id;
      if (id !== LOGINTOOLTIP_ID) {
        e.stopPropagation();
      }
    };
    var onClickOpenApp = () => {
      handleOpenApp(GATEWAY);
    };
    var getWindowSize = /*#__PURE__*/function () {
      var _ref5 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee5() {
        var _useWindowSize, height;
        return _regeneratorRuntime().wrap(function _callee5$(_context5) {
          while (1) switch (_context5.prev = _context5.next) {
            case 0:
              _context5.next = 2;
              return nextTick();
            case 2:
              _useWindowSize = useWindowSize(), height = _useWindowSize.height;
              gatewayPageHeight.value = height.value;
            case 4:
            case "end":
              return _context5.stop();
          }
        }, _callee5);
      }));
      return function getWindowSize() {
        return _ref5.apply(this, arguments);
      };
    }();
    onBeforeMount( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee6() {
      var _route$query;
      return _regeneratorRuntime().wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            if ((_route$query = route.query) !== null && _route$query !== void 0 && _route$query.isShare) {
              isShowLoginToolTip.value = true;
            }
          case 1:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    })));
    var onPullRefresh = () => {
      isPullRefresh.value = true;
      isPullRefreshDisabled.value = true;
      if (isShowWidgetComponent.value) {
        combineWidgetComponents();
      } else {
        recommendListRef.value.onPullRefresh();
      }
    };
    onMounted( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee7() {
      return _regeneratorRuntime().wrap(function _callee7$(_context7) {
        while (1) switch (_context7.prev = _context7.next) {
          case 0:
            if (isShowLoginToolTip.value) {
              document.addEventListener('click', handlePageClick, true);
            }
            store.commit(`navigator/${SET_AGENT_DATA}`, {
              top: 0
            });
            _context7.next = 4;
            return isLoginAuthenticated(false);
          case 4:
            isLogin.value = !_context7.sent;
            isShowLoading.value = true;
            _context7.next = 8;
            return isShowPIPLConfirmAlertView(false);
          case 8:
            isShowWidgetComponent.value = !_context7.sent;
            isShowLoading.value = false;
            getWindowSize();
            if (isShowWidgetComponent.value) {
              Bridge.callFn('getDataFromMemoryCache', {
                key: 'isGatewayWidgetPopupCalled'
              }, res => {
                if (getType(res.value) === 'object' && !isShowLoginToolTip.value) {
                  getWidgetPopupInfo();
                }
              });
              getGatewayFloatingWindow();
              combineWidgetComponents();
            }
            Bridge.callFn('onGatewayElementMounted', {}, () => {});
          case 13:
          case "end":
            return _context7.stop();
        }
      }, _callee7);
    })));
    onActivated( /*#__PURE__*/_asyncToGenerator( /*#__PURE__*/_regeneratorRuntime().mark(function _callee8() {
      var navDom, componentWrapperDom;
      return _regeneratorRuntime().wrap(function _callee8$(_context8) {
        while (1) switch (_context8.prev = _context8.next) {
          case 0:
            navDom = document.querySelector('.nav-wrapper');
            nextTick(() => {
              store.commit('navigator/setNavHeight', navDom === null || navDom === void 0 ? void 0 : navDom.clientHeight);
            });
            componentWrapperDom = document.querySelector('.component-wrapper');
            if (componentWrapperDom) {
              componentWrapperDom.scrollTop = store.state.landingPage.gatewayScrollTop;
            }
          case 4:
          case "end":
            return _context8.stop();
        }
      }, _callee8);
    })));
    onBeforeRouteLeave(() => {
      var componentWrapperDom = document.querySelector('.component-wrapper');
      if (componentWrapperDom) {
        store.commit(`landingPage/getGatewayScrollTop`, componentWrapperDom.scrollTop);
      }
    });
    onUnmounted(() => {
      store.commit(`navigator/${SET_AGENT_DATA}`);
    });
    return (_ctx, _cache) => {
      var _component_amz_pull_refresh = _resolveComponent("amz-pull-refresh");
      var _component_van_button = _resolveComponent("van-button");
      var _component_back_top = _resolveComponent("back-top");
      var _directive_loading = _resolveDirective("loading");
      return _withDirectives((_openBlock(), _createElementBlock("div", _hoisted_1, [isShowWidgetComponent.value ? (_openBlock(), _createElementBlock(_Fragment, {
        key: 0
      }, [_createVNode(LoginTooltip, {
        isShow: isShowLoginToolTip.value,
        showPageType: _unref(DETAIL_PAGE),
        onHandleLogin: onClickOpenApp
      }, null, 8, ["isShow", "showPageType"]), _createElementVNode("div", {
        class: "component-wrapper",
        style: _normalizeStyle({
          'padding-top': distanceFromTop.value + 'px'
        })
      }, [_createVNode(_component_amz_pull_refresh, {
        isLoad: isPullRefresh.value,
        onOnRefresh: onPullRefresh,
        isDisabled: isPullRefreshDisabled.value
      }, {
        content: _withCtx(() => [widgetList.value.length ? (_openBlock(), _createBlock(SearchWidget, {
          key: 0
        })) : _createCommentVNode("", true), (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(widgetList.value, (componentItem, componentIndex) => {
          return _openBlock(), _createBlock(_resolveDynamicComponent(filterComponent(componentItem.categoryType)), {
            style: _normalizeStyle(setComponentPaddingBottom(componentIndex)),
            key: componentItem.uuid,
            properties: componentItem
          }, null, 8, ["style", "properties"]);
        }), 128))]),
        _: 1
      }, 8, ["isLoad", "isDisabled"])], 4), isShowLoginToolTip.value ? (_openBlock(), _createElementBlock("div", _hoisted_2, [_createVNode(_component_van_button, {
        id: _unref(LOGINTOOLTIP_ID),
        round: "",
        onClick: onClickOpenApp
      }, {
        default: _withCtx(() => [_createTextVNode(_toDisplayString(_unref(t)('modules.detailPage.GO_APP_VIEW')), 1)]),
        _: 1
      }, 8, ["id"])])) : _createCommentVNode("", true)], 64)) : _withDirectives((_openBlock(), _createElementBlock("div", {
        key: 1,
        class: "not-pipl-gateway",
        style: _normalizeStyle({
          paddingTop: distanceFromTop.value + 'px'
        })
      }, [_createElementVNode("div", {
        class: "not-pipl-gateway-logo"
      }, [_createElementVNode("img", {
        src: BADGE_LOGO_URL,
        alt: ""
      })]), _createElementVNode("div", _hoisted_3, [_createElementVNode("div", {
        class: "gateway-search-box",
        onClick: _cache[0] || (_cache[0] = $event => _unref(router).push('/search'))
      }, [_createElementVNode("img", {
        src: SEARCH_URL,
        alt: ""
      }), _createElementVNode("span", null, _toDisplayString(_ctx.$t('modules.detailPage.SEARCH')), 1)])]), _createVNode(_component_amz_pull_refresh, {
        isLoad: isPullRefresh.value,
        onOnRefresh: onPullRefresh,
        isDisabled: isPullRefreshDisabled.value
      }, {
        content: _withCtx(() => [_createVNode(RecommendedAsins, {
          ref_key: "recommendListRef",
          ref: recommendListRef,
          title: _ctx.$t('modules.detailPage.BEST_SELLING_ITEM_RECOMMENDATION'),
          onIsLoading: onRecommendListLoading
        }, {
          loading: _withCtx(() => [_hoisted_4]),
          _: 1
        }, 8, ["title"])]),
        _: 1
      }, 8, ["isLoad", "isDisabled"]), _createVNode(_component_back_top, {
        scrollRef: ".pull-refresh-container",
        bottom: BACK_TOP_DISTANCE_FROM_BOTTOM,
        style: _normalizeStyle({
          marginBottom: tabbarHeight.value + loginTooltipHeight.value + 'px'
        })
      }, null, 8, ["style"])], 4)), [[_directive_loading, isNoPiplGatewayLoading.value]]), isPIPLAuthorized.value ? (_openBlock(), _createBlock(LoginTooltip, {
        key: 2,
        isShow: isLogin.value,
        showPageType: _unref(GATEWAY),
        onHandleLogin: handleLogin,
        style: _normalizeStyle({
          marginBottom: tabbarHeight.value + 'px'
        })
      }, null, 8, ["isShow", "showPageType", "style"])) : _createCommentVNode("", true), _createVNode(FloatingWindow, {
        class: _normalizeClass({
          'floating-window-bottom-wrapper': isShowLoginToolTip.value
        }),
        isFloatingWindowBottom: isShowLoginToolTip.value,
        floatingData: floatingData.value,
        isShowFloatingWindow: isShowFloatingWindow.value,
        offsetTop: gatewayPageHeight.value,
        scrollRef: ".component-wrapper"
      }, null, 8, ["class", "isFloatingWindowBottom", "floatingData", "isShowFloatingWindow", "offsetTop"]), _createVNode(PopupWidget, {
        widgetList: popupWidgetList.value
      }, null, 8, ["widgetList"])])), [[_directive_loading, isShowLoading.value]]);
    };
  }
};